<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap>
      <v-flex>
        <v-card-title class="elevation-0">
          <!-- <span class="itemHeading">TARGET LOGS</span> -->
          <v-spacer></v-spacer>
          <v-flex xs12 align-self-center pt-2>
            <v-layout wrap justify-start>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2 pt-lg-0 pt-md-0 pt-sm-0 pt-2>
                <v-text-field
                  v-model="searchKeyword"
                  label="Search Logs"
                  outlined
                  dense
                  hide-details
                  clearable
                  @input="fetchLogs(1)"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>

        <v-layout wrap justify-start px-4>
          <v-flex xs12 pt-3>
            <v-simple-table class="align-center">
              <template v-slot:default>
                <thead style="background-color: #005f32">
                  <tr>
                    <th style="color: #ffffff; font-family: kumbhRegular;" class="text-left">Date & Time</th>
                    <th style="color: #ffffff; font-family: kumbhRegular;" class="text-left">Action</th>
                    <th style="color: #ffffff; font-family: kumbhRegular;" class="text-left">Performed By</th>
                    <th style="color: #ffffff; font-family: kumbhRegular;" class="text-left">Details</th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <template v-if="logs.length > 0">
                    <tr v-for="log in logs" :key="log._id" class="text-left">
                      <td><span style="font-family: kumbhMedium;">{{ formatDate(log.createdAt || log.timestamp) }}</span></td>
                      <td>
                        <span style="font-family: kumbhMedium; text-transform: capitalize;">
                          {{ log.action }}
                        </span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium;">{{ getPerformedBy(log) }}</span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium;">{{ log.details || '-' }}</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="4" class="text-center py-4">No logs found</td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center v-if="pages > 0">
          <v-flex align-self-center>
            <div class="pt-2">
              <v-pagination
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                :length="pages"
                :total-visible="7"
                v-model="currentPage"
                color="#005f32"
                @input="fetchLogs"
              ></v-pagination>
            </div>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "TargetLogs",
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      msg: "",
      logs: [],
      currentPage: 1,
      pages: 0,
      searchKeyword: "",
    };
  },
  mounted() {
    this.fetchLogs(1);
  },
  methods: {
    getPerformedBy(log) {
      if (log.performedByName) return log.performedByName;
      if (log.performedBy) {
        if (typeof log.performedBy === 'object' && log.performedBy.name) {
          return log.performedBy.name;
        }
        if (typeof log.performedBy === 'string') {
          try {
            const parsed = JSON.parse(log.performedBy);
            if (parsed && parsed.name) return parsed.name;
          } catch (e) {
            // Not a JSON string
          }
          // If it's a 24-character hex string (MongoDB ObjectID), we shouldn't show it.
          if (/^[a-fA-F0-9]{24}$/.test(log.performedBy)) {
            return 'Unknown User';
          }
          return log.performedBy;
        }
      }
      return 'System';
    },
    getTargetInfo(log) {
      if (log.targetId && log.targetId.Targets) {
        return log.targetId.Targets;
      }
      if (log.targetInfo) {
        return log.targetInfo;
      }
      // Fallback: Extract from details if it says "Removed target: ..." or similar
      if (log.details && log.details.includes('target: ')) {
        let parts = log.details.split('target: ');
        if (parts.length > 1 && parts[1].trim() !== '') {
          return parts[1].trim();
        }
      }
      return '-';
    },
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD MMM YYYY, hh:mm A");
    },
    fetchLogs(page = this.currentPage) {
      this.appLoading = true;
      this.currentPage = page;
      
      const params = {
        page: this.currentPage,
        limit: 20,
        keyword: this.searchKeyword
      };

      axios
        .get("/admin/target/logs", {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          params: params
        })
        .then((response) => {
          this.appLoading = false;
          if (response.data && response.data.status) {
            this.logs = response.data.data || [];
            this.pages = response.data.totalPages || 1;
          } else {
            this.logs = response.data.data || response.data || [];
            this.pages = response.data.totalPages || response.data.pages || Math.ceil((response.data.total || this.logs.length) / 20);
          }
        })
        .catch((error) => {
          this.appLoading = false;
          console.error("Error fetching logs", error);
          this.showsnackbar = true;
          this.msg = "Failed to load target logs";
          this.logs = [];
        });
    },
  },
};
</script>

<style scoped>
.kumbhMedium {
  font-family: "kumbhMedium", sans-serif;
}
.kumbhRegular {
  font-family: "kumbhRegular", sans-serif;
}
</style>
